export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Ausgaben (EVU)',
            data: [0],
            backgroundColor: "rgba(251, 191, 36, 0.7)",
        },
        {
            label: 'Saldo (Netto)',
            data: [0],
            backgroundColor: "rgba(34, 197, 94, 0.85)",
        }
    ]
};
